import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import {
  ClientsService,
  SelectedClient,
} from 'src/app/services/clients/clients.service';
import { ErrorSnackbarComponent } from 'src/app/snackbars/error-snackbar/error-snackbar.component';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-client-options',
  templateUrl: './client-options.component.html',
  styleUrls: ['./client-options.component.scss'],
  imports: [
    MatRadioGroup,
    FormsModule,
    ReactiveFormsModule,
    MatRadioButton,
    MatTooltip,
    TranslateModule,
  ],
})
export class UserOptionsComponent implements OnInit, OnDestroy {
  private clientsService = inject(ClientsService);
  private snackBar = inject(MatSnackBar);
  private translate = inject(TranslateService);
  private readonly destroy = new Subject<void>();

  readonly formal = 'formal' as const;
  readonly informal = 'informal' as const;

  readonly toneOfVoice = new FormControl<
    typeof this.formal | typeof this.informal
  >(this.informal, { validators: Validators.required, nonNullable: true });

  saveCount: number = 0;

  ngOnInit(): void {
    this.clientsService.selectedClientSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((client: SelectedClient | null) => {
        if (!client) {
          return;
        }

        if (client.default_tone_of_voice) {
          this.toneOfVoice.setValue(client.default_tone_of_voice, {
            emitEvent: false,
          });
        } else {
          this.toneOfVoice.setValue(this.informal);
        }
      });

    this.toneOfVoice.valueChanges
      .pipe(takeUntil(this.destroy), debounceTime(777))
      .subscribe(async (change) => {
        try {
          await this.clientsService.updateDefaultToneOfVoice(change);

          ++this.saveCount;
          setTimeout(() => --this.saveCount, 2500);
        } catch (error) {
          console.log(error);
          this.snackBar.openFromComponent(ErrorSnackbarComponent, {
            data: {
              message: this.translate.instant('ERROR_MESSAGES.UNKNOWN_ERROR'),
              action: this.translate.instant('OK'),
            },
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
